import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import SearchModal from '../SearchModal/SearchModal';
import * as palette from '@mlc/mlc-palette';
import * as Styled from './styled';
import topMenuTestIds from '../TopMenu.elements';

interface SearchComponentProps {}
interface SearchComponentState {
	displaySearchBar: boolean;
	searchText?: string;
}

const IGNORE_ON_CLICK_OUTSIDE_CLASS = 'search-modal';

class Search extends React.Component<
	SearchComponentProps,
	SearchComponentState
> {
	public state: SearchComponentState;
	public searchModalContainerRef: React.RefObject<HTMLDivElement>;

	constructor(props: SearchComponentProps) {
		super(props);
		this.state = {
			displaySearchBar: false,
		};
		this.searchModalContainerRef = React.createRef();
	}

	toggleSearchBar = (event: any) => {
		this.setState({ displaySearchBar: !this.state.displaySearchBar });
		if (this.state.displaySearchBar) {
			event && event.preventDefault();
		}
	};

	handleKeywordUpdate = (keyword: string) => {
		this.setState({
			searchText: keyword,
		});
	};

	render() {
		return (
			<React.Fragment>
				<Styled.Button
					className={IGNORE_ON_CLICK_OUTSIDE_CLASS}
					onClick={this.toggleSearchBar}
					onKeyUp={event => {
						if (event.keyCode === 13) {
							this.toggleSearchBar(event);
						}
					}}
					style={
						this.state.displaySearchBar
							? {
									backgroundColor: palette.mlcDeepOrange,
									color: palette.mlcWhite,
							  }
							: undefined
					}
					data-id={topMenuTestIds.topMenuSearchButton}
				>
					<FontAwesomeIcon icon={faSearch} />
				</Styled.Button>
				<Styled.SearchDiv
					id={topMenuTestIds.topMenuSearch}
					aria-expanded={this.state.displaySearchBar ? 'true' : 'false'}
					aria-label="Search"
					ref={this.searchModalContainerRef}
				>
					{this.state.displaySearchBar ? (
						<SearchModal
							onClickOutside={this.toggleSearchBar}
							onKeywordUpdate={this.handleKeywordUpdate}
							searchText={this.state.searchText}
							parentRef={this.searchModalContainerRef}
							outsideClickIgnoreClass={IGNORE_ON_CLICK_OUTSIDE_CLASS}
							data-id={topMenuTestIds.topMenuSearchModal}
						/>
					) : null}
				</Styled.SearchDiv>
			</React.Fragment>
		);
	}
}
export default Search;
